import { Component, AfterViewInit, OnInit } from '@angular/core';

import { AuthService } from 'angularx-social-login';
import { FacebookLoginProvider, GoogleLoginProvider, LinkedInLoginProvider } from 'angularx-social-login';
import { SocialUser } from 'angularx-social-login';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs';
declare var $: any;

declare const gapi: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewInit, OnInit {

  title = 'JavaSampleApproach';
  description = 'Angular-Firebase Demo';

  itemValue = '';
  items: Observable<any[]>;




private user: SocialUser;
private loggedIn: boolean;

  constructor(private authService: AuthService, public db: AngularFireDatabase) {
    this.items = db.list('items').valueChanges();
   }

   onSubmit() {
    this.db.list('/items').push({ content: this.itemValue });
    this.itemValue = '';
  }
  signInWithGoogle(): void {
    this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
  }

  signInWithFB(): void {
    this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
  }
  signInWithLinkedIn(): void {
    this.authService.signIn(LinkedInLoginProvider.PROVIDER_ID);
  }

  signOut(): void {
    this.authService.signOut();
  }

  ngOnInit() {
    this.authService.authState.subscribe((user) => {
      this.user = user;
      this.loggedIn = (user != null);
    });
  }




  ngAfterViewInit () {

  $(document).ready(function() {
    $('.slider').slider({
      indicators: false
    });
  });
  // Modal Jquery Initialization
  $(document).ready(function() {
    // the "href" attribute of the modal trigger must specify the modal ID that wants to be triggered
    $('.modal').modal();
  });
  $(document).ready(function() {
    $('.sidenav').sidenav();
  });

}
}
